import { GameWidget } from './component';


export default GameWidget;
